import AddInterpreter from 'components/interpreter/AddInterpreter';
import React, { useEffect } from 'react';
import FullPageLoader from 'components/common/FullPageLoader';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { interpreterSelector, getInterpreterById, addInterpreterChat } from 'slices/interpreterSlice';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';

const InterpreterUpdate = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { id } = useParams();
    const { t } = useTranslation();

    const { singleInterpreter, loader } = useSelector(interpreterSelector);

    useEffect(() => {
        if (id) {
            dispatch(getInterpreterById(id));
        }
    }, [dispatch, id]);

    const handleChatClick = () => {
        dispatch(addInterpreterChat(id, (status, message) => {
            if (status) {
                // toast.success(message || "Chat initiated successfully");
                navigate("/chat?interpreter_id=" + id);
            } else {
                toast.error(message || t('interpreter.failedToInitiateChat'));
            }
        }));
    };

    if (loader && !singleInterpreter) return <FullPageLoader />;

    if (!singleInterpreter) return <div>{t('interpreter.noInterpreterFound')}</div>;

    return (
        <div className='content'>
            <div className="row_main_head">
                <div className='d-flex align-items-center gap-2'>
                    <button className="main_heading back_button" onClick={() => navigate(-1)}>
                        <i className="fa-solid fa-arrow-left"></i> {t('common.back')}
                    </button>
                    <h2 className="main_heading">{t('interpreter.updateVendor')}</h2>
                </div>
                <div>
                    {/* <button className='main_button  green' onClick={handleChatClick}>
                        Chat
                    </button> */}
                </div>
            </div>

            <AddInterpreter item={singleInterpreter} />
        </div>
    );
};

export default InterpreterUpdate;